<template>
  <div class="SubNavigationTabs">
    <v-tabs
      :ref="componentRef"
      v-model="activeTab"
      :centered="centeredTabs"
      :mobile-breakpoint="0"
    >
      <slot :active-tab="activeTab"></slot>
    </v-tabs>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  name: "SubNavigationTabs",
  props: {
    pageMapping: { type: Array, default: () => [] },
    pageTitle: { type: String, required: true },
    id: { type: String, required: true },
    centeredTabs: { type: Boolean, default: false },
  },
  computed: {
    ...mapState({ layout: (state) => state.theme.layout }),
    activeTab: {
      get() {
        const { show } = this.$route.query;
        const pageIndex = this.pageMapping.indexOf(show);
        return pageIndex || 0;
      },
      set(selectedTab) {
        this.$router.replace({
          query: { show: this.pageMapping[selectedTab] },
        });
      },
    },
    componentRef() {
      return `${this.id}SubNavigation`;
    },
  },
  mounted() {
    const container = this.$refs[this.componentRef];
    container.$el.querySelector(
      "div[role='tablist']"
    ).ariaLabel = `${this.pageTitle} information`;
    const tabs = container.$el.querySelectorAll('[role="tab"]');

    const ARROW_LEFT = 37;
    const ARROW_UP = 38;
    const ARROW_RIGHT = 39;
    const ARROW_DOWN = 40;

    tabs.forEach((tab, i) => {
      tab.onkeydown = (e) => {
        const eventCode = e.keyCode;
        if (eventCode === ARROW_LEFT || eventCode === ARROW_UP) {
          tabs[i - 1] ? tabs[i - 1].focus() : tabs[tabs.length - 1].focus();
        } else if (eventCode === ARROW_RIGHT || eventCode === ARROW_DOWN) {
          tabs[i + 1] ? tabs[i + 1].focus() : tabs[0].focus();
        }
      };
    });
  },
};
</script>
